import { useEffect, useRef, useState } from "react";
import Encryption from "./models/Encryption";
import "./style.css";
import { IfcEmbedderProps } from "./IfcEmbedder.types";
import { useWorker } from "../../../workers/worker-provider";
import { Loader } from "taltech-styleguide";

function IfcEmbedder({
  fileUrl,
  style,
  iFrameUrl,
  ...rest
}: IfcEmbedderProps): JSX.Element {
  const [token, setToken] = useState<string | null>(null);
  const [iframeUrl, setIframeUrl] = useState<string | null>(null);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [loading, setLoading] = useState(true);
  const { isWorking, onPostMessage, setWorker } = useWorker();
  // const REACT_APP_IFRAME_URL =
  //   "https://taltech-edubim-test-euw-webdistellar-app.azurewebsites.net";
  useEffect(() => {
    const encryption = new Encryption(rest);
    setToken(encryption.getToken());
  }, []);

  useEffect(() => {
    if (token) {
      setIframeUrl(
        `${iFrameUrl}?showDonation=false&showSettings=true&showSearch=true&mode=light&lang=en&token=${token}`
      );
    }
  }, [token]);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      const iframeLoadHandler = () => {
        showFile();
      };
      iframe.addEventListener("load", iframeLoadHandler);
      return () => iframe.removeEventListener("load", iframeLoadHandler);
    }
  }, [iframeUrl]);

  function showFile() {
    const readFile = async () => {
      if (isWorking) return;
      const worker = new Worker(
        new URL("../../../workers/download_and_convert_ifc_file.ts", import.meta.url)
      );
      setWorker(worker).then((res) => {
        if (res) {
          onPostMessage(
            { fileUrl },
            {
              workerName: "download_and_convert_ifc_file",
              workerUrl: "download_and_convert_ifc_file.ts",
              data: { fileUrl },
              successMessage: "File read successfully",
              pendingMessage: "Reading file...",
              errorMessage: "Failed to read file",
              onSuccess: (data: any) => {
                sendFile(data);
                setLoading(false);
              },
              onError: () => {
                console.error("Failed to fetch the file: ");
              },
            }
          );
        }
      });
    };

    const sendFile = (ifcText: string) => {
      if (iframeRef.current) {
        const iframe = iframeRef.current;
        iframe.contentWindow?.postMessage(
          { func: "loadFile", file: { name: "model.ifc", contents: ifcText } },
          "*"
        );
      }
    };

    if (iframeUrl) {
      readFile();
    }
  }

  return (
    <>
      {loading && <Loader fullScreen />}
      <div id="iframe-div">
        <iframe
          style={style}
          ref={iframeRef}
          id="iframe_id"
          className="iframe-style"
          src={iframeUrl ?? ""}
          title="map"
        ></iframe>
      </div>
    </>
  );
}

export default IfcEmbedder;
